import { css } from "@emotion/react";
import React from "react";
import { PartialColorProps, useTheme } from "../theme";

export interface LegendProps
  extends
    PartialColorProps,
    Omit<React.ComponentPropsWithoutRef<"p">, "color"> {
  /**
   * 表示するアイコンを指定します。指定しない場合、デフォルトのアイコンを用いられます。
   */
  icon?: React.ReactNode;
  children: React.ReactNode;
}

const DefaultIcon = () => {
  return (
    <svg
      stroke="currentColor"
      fill="currentColor"
      strokeWidth="0"
      viewBox="0 0 448 512"
      height="1em"
      width="1em"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48z" />
    </svg>
  );
};

export const Legend = ({
  color = "default",
  icon,
  children,
  ...props
}: LegendProps) => {
  const theme = useTheme();
  return (
    <p
      css={[
        theme.typography.caption,
        css`
          display: flex;
          align-items: center;
          white-space: nowrap;
        `,
      ]}
      {...props}
    >
      <span
        css={css`
          display: flex;
          align-items: center;
          margin-right: 0.5ch;
          font-size: 1.5em;
          color: ${color === "default"
            ? theme.palette.action.disabled
            : theme.palette.intentions[color].main};
        `}
      >
        {icon ?? <DefaultIcon />}
      </span>
      <span>{children}</span>
    </p>
  );
};
